export default {
  'whiteLabel.title': 'Marca blanca',
  'whiteLabel.description':
    'Configura la marca de tu compañía y el dominio personalizado. Los cambios se aplican cuando el runtime refresca la marca efectiva.',

  'whiteLabel.sections.effective': 'Marca efectiva',
  'whiteLabel.sections.branding': 'Marca local',
  'whiteLabel.sections.domain': 'Dominio personalizado',
  'whiteLabel.sections.previews': 'Vistas previas',

  'whiteLabel.effective.source.own': 'Propia',
  'whiteLabel.effective.source.inherited': 'Heredada',
  'whiteLabel.effective.defaultBrand': 'AUTOMY',
  'whiteLabel.effective.empty': 'No se pudo cargar la marca efectiva.',
  'whiteLabel.effective.vsLocalHint':
    'Efectiva es lo que ven los usuarios (propia, heredada del canal o AUTOMY). Local es lo que edita esta compañía.',
  'whiteLabel.effective.assets': 'Recursos',
  'whiteLabel.effective.automyDefaults': 'Valores por defecto de AUTOMY',

  'whiteLabel.form.applyToChildren': 'Aplicar a hijas',
  'whiteLabel.form.applyToChildren.hint':
    'Si está habilitada, las compañías hijas del canal pueden heredar esta marca.',
  'whiteLabel.form.isActive.offHint':
    'Esta compañía dejará de mostrar marca personalizada y no heredará del canal. El runtime usará AUTOMY.',
  'whiteLabel.form.brandName': 'Nombre de marca',
  'whiteLabel.form.mainColor': 'Color principal',
  'whiteLabel.form.logo': 'Logo',
  'whiteLabel.form.iconLogo': 'Logo ícono',
  'whiteLabel.form.favicon': 'Favicon',
  'whiteLabel.form.font': 'Fuente (WOFF2)',
  'whiteLabel.form.loginSplash': 'Splash de login',
  'whiteLabel.form.supportEmail': 'Correo de soporte',
  'whiteLabel.form.supportEmail.hint':
    'Solo contacto visual. El remitente de emails sigue siendo AUTOMY (no SMTP).',
  'whiteLabel.form.contrastSample': 'Aa',
  'whiteLabel.form.assetHint': '{extensions}. Máx. {maxSize}. No se permite SVG.',
  'whiteLabel.form.assetHint.font': '{extensions}. Máx. {maxSize}.',
  'whiteLabel.form.assetHint.unavailable':
    'No se pudieron cargar los requisitos de archivo. La subida no está disponible.',

  'whiteLabel.validation.brandNameMax': 'El nombre de marca admite máximo 120 caracteres.',
  'whiteLabel.validation.mainColor': 'Usa un color hex como #2255AA.',
  'whiteLabel.validation.supportEmail': 'Ingresa un correo válido.',
  'whiteLabel.validation.supportEmailMax': 'El correo admite máximo 320 caracteres.',
  'whiteLabel.validation.customDomainRequired': 'Ingresa un hostname.',
  'whiteLabel.validation.customDomainInvalid':
    'Ingresa un hostname sin protocolo, puerto ni path. Los dominios bajo automy.global están reservados.',
  'whiteLabel.validation.asset.required': 'Selecciona un archivo para {slot}.',
  'whiteLabel.validation.asset.noName': 'Falta el nombre del archivo de {slot}.',
  'whiteLabel.validation.asset.empty': 'El archivo de {slot} está vacío.',
  'whiteLabel.validation.asset.svg': 'No se permiten archivos SVG en {slot}. Usa {allowed}.',
  'whiteLabel.validation.asset.extension':
    'La extensión {extension} no está permitida en {slot}. Usa {allowed}.',
  'whiteLabel.validation.asset.mime':
    'Este tipo de archivo no está permitido en {slot}. Usa {allowed}.',
  'whiteLabel.validation.asset.size': 'El archivo de {slot} supera el tamaño máximo de {maxSize}.',
  'whiteLabel.validation.asset.uploadFailed': 'No se pudo subir el archivo. Inténtalo de nuevo.',

  'whiteLabel.domain.saveBrandingFirst':
    'Guarda primero la marca local antes de configurar un dominio personalizado.',
  'whiteLabel.domain.noInheritanceHint':
    'Los dominios no se heredan. Solo se configuran en la compañía dueña.',
  'whiteLabel.domain.step.register': 'Registrar',
  'whiteLabel.domain.step.verify': 'Verificar DNS',
  'whiteLabel.domain.step.activate': 'Activar',
  'whiteLabel.domain.step.live': 'En vivo',
  'whiteLabel.domain.status.notConfigured': 'Sin configurar',
  'whiteLabel.domain.status.pending': 'Pendiente de verificación',
  'whiteLabel.domain.status.verified': 'Verificado',
  'whiteLabel.domain.status.active': 'Activo',
  'whiteLabel.domain.status.disabled': 'Deshabilitado',
  'whiteLabel.domain.field.hostname': 'Dominio personalizado',
  'whiteLabel.domain.field.hostnameHint': 'Solo hostname, p. ej. brand.acme.com',
  'whiteLabel.domain.field.hostnamePlaceholder': 'brand.example.com',
  'whiteLabel.domain.actions.register': 'Registrar dominio',
  'whiteLabel.domain.actions.verify': 'Verificar DNS',
  'whiteLabel.domain.actions.activate': 'Activar dominio',
  'whiteLabel.domain.actions.disable': 'Desactivar dominio',
  'whiteLabel.domain.actions.clear': 'Retirar dominio',
  'whiteLabel.domain.txtOneShotHint':
    'Agrega este registro TXT en tu DNS. El token de verificación se muestra solo una vez.',
  'whiteLabel.domain.txtName': 'Nombre TXT',
  'whiteLabel.domain.txtValue': 'Valor TXT',
  'whiteLabel.domain.txtMissing':
    'El token de verificación ya no está disponible. Si no configuraste el DNS, retira el dominio y regístralo de nuevo.',
  'whiteLabel.domain.verifyPending':
    'El DNS aún no ha propagado. El dominio sigue pendiente de verificación.',
  'whiteLabel.domain.verifiedHint':
    'El DNS coincidió. Puedes activar el dominio. TLS/CDN se gestionan fuera de esta pantalla.',
  'whiteLabel.domain.activeHint': 'Este dominio está activo para servir.',
  'whiteLabel.domain.disabledHint':
    'El dominio está deshabilitado y no se servirá. Retíralo para empezar de nuevo, o contacta soporte si necesitas reactivarlo.',
  'whiteLabel.domain.confirm.disableTitle': '¿Desactivar dominio personalizado?',
  'whiteLabel.domain.confirm.disableContent':
    'El dominio dejará de servirse. La configuración de marca se conserva.',
  'whiteLabel.domain.confirm.clearTitle': '¿Retirar dominio personalizado?',
  'whiteLabel.domain.confirm.clearContent':
    'Se borra la configuración del dominio. Deberás registrar y verificar de nuevo.',

  'whiteLabel.preview.tab.effective': 'Efectiva',
  'whiteLabel.preview.tab.local': 'Local',
  'whiteLabel.preview.desktop': 'Desktop',
  'whiteLabel.preview.email': 'Email',
  'whiteLabel.preview.sampleBody': 'Contenido de ejemplo con los estilos de tu marca.',
  'whiteLabel.preview.sampleCta': 'Continuar',

  'whiteLabel.errors.versionConflict':
    'Esta configuración cambió en otro lugar. Se recargó la data local — revisa y guarda de nuevo.',
  'whiteLabel.errors.loadFailed':
    'No se pudo cargar la marca local. No se puede guardar hasta recargar.',
  'whiteLabel.errors.forbidden':
    'No tienes permiso para ver la configuración de marca blanca.',
  'whiteLabel.errors.writeForbidden':
    'No tienes permiso para modificar la configuración de marca blanca.',
};
